/** Helpers behind components/brand/BrandLogo. */

/**
 * URLs that are not a brand's own logo: our upload placeholder and the
 * generated letter avatars older signups stored. Treated as "no logo" so the
 * fallback below paints the initials in the brand's colour instead of the
 * fixed indigo baked into those images.
 */
export function isGeneratedAvatar(url: string | null | undefined): boolean {
  if (!url) return true;
  return (
    url.includes("/placeholder/no-image") ||
    url.includes("ui-avatars.com") ||
    url.includes("placehold.co") ||
    url.includes("/default-brand-logo")
  );
}

/** Up to two initials from a company name ("Acme Outfitters" → "AO"). */
export function brandInitials(name: string | null | undefined): string {
  const parts = (name ?? "").trim().split(/\s+/).filter(Boolean);
  const letters = parts.map((p) => p.charAt(0)).join("").toUpperCase();
  return letters.slice(0, 2) || "B";
}

/** Initials for a person ("Whisperwind Wares" → "WW"); "?" when the name is empty. */
export function personInitials(name: string | null | undefined): string {
  return (name ?? "").trim() ? brandInitials(name) : "?";
}
